import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    breadcrumbsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      background: 'white',
      margin: '-15px -15px 20px -15px',
      padding: '14px 16px',
      // padding: 15,
      borderTop: '1px solid rgba(0,0,0,0.14)',
      minHeight: 35,
      alignItems: 'center'
    },
    breadcrumbsTitle: {
      color: '#111827',
      fontSize: 22,
      fontWeight: 600,
      marginRight: 12,
    },
    breadcrumbsItem: {
      color: props.color2,
      fontWeight: 500,
      fontSize: 13,
      textDecoration: 'underline'
    },

    '@media (max-width: 600px)': {
      breadcrumbsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        background: 'white',
        margin: '-15px -15px 20px -15px',
        padding: '14px 16px',
        borderTop: '1px solid rgba(0,0,0,0.14)',
        minHeight: 35,
      },
      breadcrumbsTitle: {
        color: 'var(--text-strong)',
        fontWeight: 700,
        marginRight: 0,
        marginBottom: 6,
        
      },
      breadcrumbsItem: {
        fontSize: 14,
        color: 'var(--text-link)',
      },
    }
  }));
  return styles();
}
export default theme;

